import type {
  Playbook,
  PlaybookStep,
  PlaybookInstance,
  PlaybookFrequency,
  PlaybookInstanceStatus,
} from '@/types/database';

export type { Playbook, PlaybookStep, PlaybookInstance, PlaybookFrequency, PlaybookInstanceStatus };

export interface PlaybookWithSteps extends Playbook {
  steps: PlaybookStep[];
}

export interface PlaybookInstanceWithMeta extends PlaybookInstance {
  playbook_name: string;
  playbook_frequency: PlaybookFrequency;
  client_name: string | null;
  task_total: number;
  task_completed: number;
}

export const FREQUENCY_LABELS: Record<PlaybookFrequency, string> = {
  daily: 'Diário',
  weekly: 'Semanal',
  monthly: 'Mensal',
  quarterly: 'Trimestral',
};

export const INSTANCE_STATUS_LABELS: Record<PlaybookInstanceStatus, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Concluída',
};

export const INSTANCE_STATUS_CLASSES: Record<PlaybookInstanceStatus, string> = {
  pending: 'bg-muted text-muted-foreground border-border',
  in_progress: 'bg-amber-100 text-amber-700 border-amber-200',
  completed: 'bg-income/10 text-income border-income/20',
};
